import type { PromoResponse } from '@/store/types/promo'
import T from '@/components/Helpers/Translate'
import Image from 'next/image'

type Props = {
  product: PromoResponse
}
export const PromoItem = ({ product }: Props) => (
  <div
    className="mb-2 flex flex-row space-x-4 rounded-lg bg-amber-500/10 p-3"
    key={product.data.slug}
  >
    <div key={product.data.name} className="flex">
      <Image
        width={70}
        height={70}
        alt=""
        // @ts-expect-error Cosmic sends the wrong structure for this use case
        src={product.data.image?.imageUrl || product.data.image || ''}
      />
    </div>
    <div className="about">
      <div className="text-small text-amber-500">
        <T>free</T>
      </div>
      <div className="name font-bold text-primary">{product.data.name}</div>

      <span className="text-gray-500/50">
        <T>promo_count</T>
      </span>
    </div>
  </div>
)
